

















import { Component, Vue } from 'vue-property-decorator'
import ShareModal from '@/components/ShareModal.vue'

@Component({
  components: {
    ShareModal,
  }
})
export default class App extends Vue {
  get shareModalOpen() {
    return this.$store.getters.shareModalOpen
  }
  get messageActive() {
    return this.$store.getters.messageActive
  }
  set messageActive(val) {
    this.$store.dispatch('setMessageActive', val)
  }
  public closeMessage() {
    this.$store.dispatch('setMessageActive', false)
  }
  get messageText() {
    return this.$store.getters.messageText
  }
  public created() {
    this.$store.dispatch('setCiudad', this.$route.params.ciudadSlug)
  }
  public mounted() {
    this.$store.dispatch('initGeolocation')
  }
}
